export default {
  th: {
    lang: "ภาษา",
    register: "สมัครสมาชิก",
    login: "เข้าสู่ระบบ",
    logout: "ออกจากระบบ",
    account: "บัญชีของฉัน",
    loginModal: {
      badge: "Member Login",
      title: "เข้าสู่ระบบเพื่อเริ่มช้อปและจัดการคำสั่งซื้อ",
      mobileTitle: "เข้าสู่ระบบ",
      subtitle: "Marketplace Member",
      desc: "เข้าสู่ระบบเพื่อดูคำสั่งซื้อ สินค้าที่บันทึก โปรโมชัน และประวัติการช้อปในบัญชีเดียว",
      helper: "กรอกรหัสสมาชิก อีเมล หรือเบอร์โทรศัพท์ พร้อมรหัสผ่านของคุณ",
      usernameLabel: "รหัสสมาชิก อีเมล หรือเบอร์โทรศัพท์",
      usernamePlaceholder: "กรอกข้อมูลเข้าสู่ระบบ",
      passwordLabel: "รหัสผ่าน",
      passwordPlaceholder: "กรอกรหัสผ่าน",
      rememberMe: "จำบัญชีและรหัสผ่านของฉันไว้",
      forgotPassword: "ลืมรหัสผ่าน",
      usernameRequired: "กรุณากรอกรหัสสมาชิก อีเมล หรือเบอร์โทรศัพท์",
      passwordRequired: "กรุณากรอกรหัสผ่าน",
      passwordMin: "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
      submitFail: "กรุณาตรวจสอบข้อมูลเข้าสู่ระบบอีกครั้ง",
      submitSuccess: "เข้าสู่ระบบสำเร็จ"
    },
    searchPlaceholder: "ค้นหาอุปกรณ์สำนักงาน ครุภัณฑ์ และอุปกรณ์เซฟตี้",
    search: "ค้นหา",
    show: "แสดง",
    hide: "ซ่อน",
    requestOtp: "กดรับรหัสยืนยัน",
    readMore: "อ่านเพิ่ม",
    estimate: "ขอใบเสนอราคา",
    viewProducts: "ดูหมวดสินค้า",
    viewMore: "ดูเพิ่มเติม",
    viewAll: "ดูทั้งหมด",
    loadMore: "โหลดเพิ่มเติม",
    detail: "ดูรายละเอียด",
    startRegister: "เริ่มสมัครสมาชิก",
    loading: "กำลังโหลดข้อมูล...",
    loadError: "ไม่สามารถโหลดข้อมูลจากเซิร์ฟเวอร์ได้",
    hero: {
      badge: "ร้านอุปกรณ์สำนักงานและอุปกรณ์เซฟตี้",
      title: "ฐิติมา พาณิชย์ ครบเรื่องอุปกรณ์สำนักงาน ครุภัณฑ์ ดับเพลิง กู้ชีพ กู้ภัย และงานจราจร",
      desc: "จำหน่ายสินค้าเพื่อสำนักงาน อาคาร โรงงาน โรงเรียน และหน่วยงานต่าง ๆ พร้อมให้คำแนะนำสินค้า จัดทำใบเสนอราคา และประสานงานจัดส่งได้ทั่วประเทศ"
    },
    category: { badge: "Product Categories", title: "หมวดสินค้าหลัก" },
    bestSeller: {
      badge: "Best Seller Picks",
      title: "สินค้าขายดีประจำร้าน",
      cta: "ดูทั้งหมด",
      feature1: "สินค้าสำหรับสำนักงานและอาคาร",
      feature2: "รุ่นใช้งานจริงในหน่วยงาน",
      feature3: "พร้อมแนะนำและจัดทำใบเสนอราคา",
      soldPrefix: "สอบถามต่อเนื่อง"
    },
    products: { badge: "Recommended Products", title: "สินค้าแนะนำ", all: "สินค้าทั้งหมด", items: "รายการ", addToCart: "เพิ่มลงตะกร้า" },
    flashSale: {
      badge: "Featured Items",
      title: "สินค้าเด่นและรุ่นแนะนำ",
      desc: "รวมสินค้าหมุนเวียนที่ลูกค้าสอบถามบ่อย เหมาะกับงานจัดซื้อ งานดูแลอาคาร และงานความปลอดภัย",
      cta: "ดูสินค้าแนะนำ"
    },
    services: {
      badge: "Our Services",
      title: "บริการจัดหาสินค้าและดูแลงานจัดซื้อให้ครบขึ้น",
      desc: "เราช่วยคัดสินค้าให้เหมาะกับประเภทการใช้งานของแต่ละหน่วยงาน ตั้งแต่งานสำนักงาน งานอาคาร ไปจนถึงงานความปลอดภัยและอุปกรณ์ฉุกเฉิน",
      featuredBadge: "เหมาะกับบริษัท โรงเรียน โรงงาน และหน่วยงานราชการ",
      featuredTitle: "เลือกสินค้าได้ครบจากหมวดที่ใช้งานจริง",
      featuredDesc: "รวมสินค้าหลักที่ใช้ในสำนักงานและงานดูแลสถานที่ พร้อมช่วยเทียบสเปก วางงบประมาณ และจัดทำใบเสนอราคาตามความต้องการ"
    },
    shipping: {
      badge: "Budget Estimator",
      title: "ประเมินงบประมาณเบื้องต้น",
      pricePerKg: "ราคาต่อหน่วย",
      pricePerQ: "ราคาเหมารวม",
      length: "ยาว (ซม.)",
      width: "กว้าง (ซม.)",
      height: "สูง (ซม.)",
      weightLabel: "น้ำหนัก (กก.)",
      volumeResult: "ปริมาตรโดยประมาณ",
      weightResult: "น้ำหนักโดยประมาณ",
      byWeightPrice: "ราคารวมตามจำนวน",
      byVolumePrice: "ราคารวมแบบเหมา",
      chargeByPrefix: "ระบบประเมินจาก",
      shippingFeePrefix: "งบประมาณเบื้องต้น",
      rule1: "ใช้กรอกจำนวนหรือหน่วยที่ต้องการเพื่อประเมินราคาเบื้องต้น",
      rule2: "ตัวเลขนี้ใช้ประกอบการขอใบเสนอราคาและวางแผนงบประมาณ",
      note: "แบบประเมินนี้เป็นข้อมูลเบื้องต้นสำหรับงานจัดซื้ออุปกรณ์สำนักงาน ครุภัณฑ์ และอุปกรณ์เซฟตี้ ก่อนให้ทีมงานจัดทำใบเสนอราคา"
    },
    why: { badge: "Why Choose Us", title: "เหตุผลที่ลูกค้าเลือกใช้บริการเรา" },
    import: { badge: "Product Range", title: "กลุ่มสินค้ายอดนิยม" },
    articles: { badge: "Shopping Guide", title: "บทความน่ารู้สำหรับคนช้อปและคนขาย" },
    footer: {
      menu: "เมนูหลัก",
      contact: "ติดต่อเรา",
      start: "เริ่มต้นสอบถาม",
      tagline: "จำหน่าย จัดหา และประสานงานอุปกรณ์สำหรับองค์กรและของใช้ทั่วไป",
      desc: "จำหน่ายและจัดหาอุปกรณ์สำนักงาน ครุภัณฑ์ อุปกรณ์เซฟตี้ ดับเพลิง กู้ชีพ กู้ภัย อุปกรณ์จราจร ของใช้ในครัวเรือน และสินค้าสนับสนุนอื่น ๆ พร้อมช่วยแนะนำรายการและประสานงานจัดซื้อ เริ่มต้นด้วยการปรึกษาเราก่อนได้",
      line: "ttm.service",
      lineLabel: "LINE ID",
      lineAction: "เพิ่มเพื่อน LINE",
      supportHours: "พร้อมให้คำปรึกษา แนะนำรายการสินค้า และประสานงานจัดซื้อสำหรับหน่วยงาน องค์กร โรงเรียน โรงงาน และโครงการต่าง ๆ",
      copy: "© 2026 ฐิติมา พาณิชย์. สงวนลิขสิทธิ์"
    },
    cartPage: {
      badge: "Shopping Cart",
      title: "ตะกร้าสินค้า",
      loginTitle: "เข้าสู่ระบบเพื่อดูตะกร้าสินค้า",
      loginDesc: "ตะกร้าสินค้าและคำสั่งซื้อของคุณจะถูกผูกกับบัญชีสมาชิก",
      emptyTitle: "ยังไม่มีสินค้าในตะกร้า",
      emptyDesc: "เลือกสินค้าในหน้าแรกแล้วเพิ่มลงตะกร้าเพื่อเริ่มสั่งซื้อ",
      remove: "ลบสินค้า",
      summaryTitle: "สรุปคำสั่งซื้อ",
      totalItems: "จำนวนสินค้า",
      totalAmount: "ยอดรวม",
      checkout: "สร้างคำสั่งซื้อ",
      processing: "กำลังดำเนินการ..."
    },
    accountPage: {
      badge: "My Account",
      title: "บัญชีของฉัน",
      loginTitle: "เข้าสู่ระบบเพื่อดูข้อมูลบัญชี",
      loginDesc: "หลังเข้าสู่ระบบ คุณจะดูโปรไฟล์ ประวัติคำสั่งซื้อ และสถานะการสั่งซื้อได้",
      email: "อีเมล",
      phone: "เบอร์โทรศัพท์",
      lineId: "Line ID",
      usageType: "ประเภทการใช้งาน",
      ordersTitle: "รายการสั่งซื้อ",
      goToCart: "ไปที่ตะกร้า",
      emptyOrdersTitle: "ยังไม่มีรายการสั่งซื้อ",
      emptyOrdersDesc: "เพิ่มสินค้าลงตะกร้าและสร้างคำสั่งซื้อเพื่อเริ่มใช้งานระบบ",
      orderNo: "เลขที่คำสั่งซื้อ",
      totalItems: "จำนวนชิ้น",
      totalAmount: "ยอดรวม",
      createdAt: "วันที่สร้าง"
    },
    subhead: "Marketplace Member",
    backHome: "กลับหน้าหลัก",
    contact: "ติดต่อทีมงาน",
    heroTitle: "สมัครสมาชิกเพื่อเริ่มช้อปและขายต่อสินค้าจากจีน",
    heroDesc: "สมัครสมาชิกเพื่อสั่งซื้อสินค้าบนแพลตฟอร์ม ติดตามคำสั่งซื้อ และรับสิทธิ์สำหรับร้านค้าที่ต้องการซื้อไปขายต่อ",
    benefitsTitle: "สิ่งที่สมาชิกจะได้รับ",
    registerMock: {
      windowLabel: "Member Preview",
      title: "สมัครสมาชิกเพื่อเริ่มช้อปและใช้งานหน้าร้านออนไลน์ได้เต็มรูปแบบ",
      profileTitle: "บัญชีสมาชิกพร้อมใช้งาน",
      profileDesc: "จัดการข้อมูลสมาชิก คำสั่งซื้อ และรายการสินค้าที่สนใจได้ในที่เดียว",
      benefitOneTitle: "สมัครสมาชิกได้ปลอดภัย",
      benefitOneDesc: "บันทึกข้อมูลลงฐานข้อมูลจริงพร้อม flow สมัครสมาชิกที่พร้อมต่อยอด",
      benefitTwoTitle: "ช้อปและติดตามคำสั่งซื้อได้สะดวก",
      benefitTwoDesc: "เข้าถึงดีล สินค้าที่บันทึก และประวัติการสั่งซื้อจากบัญชีเดียว",
      statsTitle: "ภาพรวมประสบการณ์สมาชิก"
    },
    accountTitle: "ข้อมูลบัญชีสมาชิก",
    required: "* กรุณากรอกข้อมูลให้ครบ",
    gender: "เพศ",
    usageTitle: "ข้อมูลการใช้งานสมาชิก",
    usageType: "คุณต้องการใช้งานแบบใด",
    source: "รู้จัก ฐิติมา พาณิชย์ จากช่องทางใด",
    selectSource: "เลือกช่องทาง",
    acceptTitle: "ยืนยันและยอมรับเงื่อนไข",
    notRobot: "กรุณายืนยันว่าไม่ใช่บอท",
    acceptPrefix: "ยอมรับ",
    terms: "เงื่อนไขการใช้บริการ",
    and: "และ",
    privacy: "นโยบายความเป็นส่วนตัว",
    otpSent: "ส่งรหัสยืนยันตัวอย่างแล้ว ระบบเดโมเติมค่า 123456 ให้โดยอัตโนมัติ",
    otpFail: "ไม่สามารถส่งรหัสยืนยันได้ กรุณาตรวจสอบเบอร์โทรก่อน",
    submitFail: "กรุณาตรวจสอบข้อมูลที่กรอกอีกครั้ง",
    submitSuccess: "สมัครสมาชิกสำเร็จ ข้อมูลถูกบันทึกลงฐานข้อมูลแล้ว"
  },
  en: {
    lang: "Language",
    register: "Register",
    login: "Login",
    logout: "Logout",
    account: "My Account",
    loginModal: {
      badge: "Member Login",
      title: "Sign in to shop and manage your orders",
      mobileTitle: "Login",
      subtitle: "Marketplace Member",
      desc: "Sign in to view orders, saved products, promotions, and shopping history in one account.",
      helper: "Enter your member code, email, or phone number together with your password.",
      usernameLabel: "Member Code, Email, or Phone",
      usernamePlaceholder: "Enter your login information",
      passwordLabel: "Password",
      passwordPlaceholder: "Enter your password",
      rememberMe: "Remember my account and password",
      forgotPassword: "Forgot password",
      usernameRequired: "Please enter your member code, email, or phone number",
      passwordRequired: "Please enter your password",
      passwordMin: "Password must be at least 6 characters",
      submitFail: "Please review your login information again",
      submitSuccess: "Login successful"
    },
    searchPlaceholder: "Search office furniture, stationery, fire safety, and rescue equipment",
    search: "Search",
    show: "Show",
    hide: "Hide",
    requestOtp: "Request Code",
    readMore: "Read More",
    estimate: "Get Quote",
    viewProducts: "Browse Categories",
    viewMore: "View More",
    viewAll: "View All",
    loadMore: "Load More",
    detail: "Details",
    startRegister: "Start Registration",
    loading: "Loading data...",
    loadError: "Unable to load data from the server.",
    hero: {
      badge: "Office and Safety Supply Store",
      title: "Thitima Panich for office supply, furniture, fire safety, rescue, emergency, and traffic equipment",
      desc: "We support offices, buildings, factories, schools, and public-sector procurement with practical products, quotation support, and nationwide delivery."
    },
    category: { badge: "Product Categories", title: "Main Categories" },
    bestSeller: {
      badge: "Best Seller Picks",
      title: "Best-Selling Store Picks",
      cta: "View All",
      feature1: "Products for office and facility use",
      feature2: "Frequently requested practical models",
      feature3: "Quotation and product guidance available",
      soldPrefix: "Active inquiries"
    },
    products: { badge: "Recommended Products", title: "Recommended Items", all: "All Products", items: "items", addToCart: "Add to Cart" },
    flashSale: {
      badge: "Featured Items",
      title: "Featured and Suggested Models",
      desc: "A rotating group of products frequently requested for office procurement, facility support, and safety operations.",
      cta: "View Featured Items"
    },
    services: {
      badge: "Our Services",
      title: "More complete support for purchasing and product sourcing",
      desc: "We help match the right products to each use case, from office operations and facility management to safety, emergency, and traffic needs.",
      featuredBadge: "Suitable for companies, schools, factories, and government units",
      featuredTitle: "Choose from categories used in real operations",
      featuredDesc: "Explore core products with support for specification comparison, budget planning, and quotation preparation."
    },
    shipping: {
      badge: "Budget Estimator",
      title: "Preliminary Budget Estimator",
      pricePerKg: "Unit Price",
      pricePerQ: "Project Price",
      length: "Length (cm)",
      width: "Width (cm)",
      height: "Height (cm)",
      weightLabel: "Weight (kg)",
      volumeResult: "Estimated Volume",
      weightResult: "Estimated Weight",
      byWeightPrice: "Quantity-Based Total",
      byVolumePrice: "Project-Based Total",
      chargeByPrefix: "The estimate is based on",
      shippingFeePrefix: "Estimated budget",
      rule1: "Enter quantities or dimensions to prepare a rough budget.",
      rule2: "Use the result to request a formal quotation from our team.",
      note: "This estimator is for preliminary budgeting of office, furniture, and safety equipment before quotation."
    },
    why: { badge: "Why Choose Us", title: "Why customers work with us" },
    import: { badge: "Product Range", title: "Popular product groups" },
    articles: { badge: "Shopping Guide", title: "Useful articles for shoppers and resellers" },
    footer: {
      menu: "Main Menu",
      contact: "Contact",
      start: "Get in Touch",
      tagline: "Supply, sourcing, and coordination for organizations and household needs",
      desc: "We support office supplies, furniture, fire safety, rescue, traffic, household items, and related categories with practical recommendations and continued coordination. Start with a consultation whenever you need guidance.",
      line: "ttm.service",
      lineLabel: "LINE ID",
      lineAction: "Add LINE friend",
      supportHours: "Ready to help with product guidance, requirement discussion, and procurement coordination for organizations and projects.",
      copy: "© 2026 Thitima Panich. All rights reserved."
    },
    cartPage: {
      badge: "Shopping Cart",
      title: "Shopping Cart",
      loginTitle: "Sign in to view your cart",
      loginDesc: "Your cart and orders are linked to your member account.",
      emptyTitle: "Your cart is empty",
      emptyDesc: "Browse products on the homepage and add items to start ordering.",
      remove: "Remove",
      summaryTitle: "Order Summary",
      totalItems: "Items",
      totalAmount: "Total",
      checkout: "Create Order",
      processing: "Processing..."
    },
    accountPage: {
      badge: "My Account",
      title: "My Account",
      loginTitle: "Sign in to view your account",
      loginDesc: "After logging in, you can review your profile, orders, and purchase status.",
      email: "Email",
      phone: "Phone",
      lineId: "Line ID",
      usageType: "Usage Type",
      ordersTitle: "Orders",
      goToCart: "Go to Cart",
      emptyOrdersTitle: "No orders yet",
      emptyOrdersDesc: "Add products to your cart and create an order to start using the commerce flow.",
      orderNo: "Order No.",
      totalItems: "Items",
      totalAmount: "Total",
      createdAt: "Created At"
    },
    subhead: "Marketplace Member",
    backHome: "Back to Home",
    contact: "Contact",
    heroTitle: "Register to shop and resell imported products",
    heroDesc: "Create an account to buy from the platform, track orders, and access reseller-friendly workflows.",
    benefitsTitle: "Member benefits",
    registerMock: {
      windowLabel: "Member Preview",
      title: "Create your account and unlock the full storefront experience",
      profileTitle: "Member account ready",
      profileDesc: "Manage profile details, orders, and saved products from one place",
      benefitOneTitle: "Secure registration flow",
      benefitOneDesc: "Data is stored in a real database and ready for future account workflows",
      benefitTwoTitle: "Shop and track orders easily",
      benefitTwoDesc: "Access deals, saved products, and order history from one account",
      statsTitle: "Member experience overview"
    },
    accountTitle: "Account Information",
    required: "* Please complete all required fields",
    gender: "Gender",
    usageTitle: "Member Usage Information",
    usageType: "How will you use the platform",
    source: "How did you hear about Thitima Panich?",
    selectSource: "Select a source",
    acceptTitle: "Confirmation and Terms",
    notRobot: "Please confirm that you are not a bot",
    acceptPrefix: "I accept the",
    terms: "Terms of Service",
    and: "and",
    privacy: "Privacy Policy",
    otpSent: "Demo verification code sent. The demo automatically fills in 123456.",
    otpFail: "Unable to send verification code. Please check the phone number first.",
    submitFail: "Please review the entered information again.",
    submitSuccess: "Registration successful. The record has been saved to the database."
  },
  cn: {
    lang: "语言",
    register: "注册会员",
    login: "登录",
    logout: "退出登录",
    account: "我的账户",
    loginModal: {
      badge: "会员登录",
      title: "登录后即可购物并管理订单",
      mobileTitle: "登录",
      subtitle: "商城会员",
      desc: "登录后可在同一账号中查看订单、收藏商品、促销活动与购物记录。",
      helper: "请输入会员编号、邮箱或手机号，以及您的密码。",
      usernameLabel: "会员编号、邮箱或手机号",
      usernamePlaceholder: "输入登录信息",
      passwordLabel: "密码",
      passwordPlaceholder: "输入密码",
      rememberMe: "记住我的账号与密码",
      forgotPassword: "忘记密码",
      usernameRequired: "请输入会员编号、邮箱或手机号",
      passwordRequired: "请输入密码",
      passwordMin: "密码至少需要 6 个字符",
      submitFail: "请再次检查登录信息",
      submitSuccess: "登录成功"
    },
    searchPlaceholder: "搜索我们从中国精选上架的商品",
    search: "搜索",
    show: "显示",
    hide: "隐藏",
    requestOtp: "获取验证码",
    readMore: "阅读全文",
    estimate: "成本估算",
    viewProducts: "查看商品",
    viewMore: "查看更多",
    viewAll: "查看全部",
    loadMore: "加载更多",
    detail: "查看详情",
    startRegister: "立即注册",
    loading: "正在加载数据...",
    loadError: "无法从服务器加载数据。",
    hero: {
      badge: "中国进口商品销售平台",
      title: "轻松选购中国进口商品，一站式完成购物",
      desc: "以大型商城风格展示中国商品，可浏览活动、比较价格、查看分类并更顺畅地下单。"
    },
    category: { badge: "商城分类", title: "热门分类" },
    bestSeller: {
      badge: "热卖精选",
      title: "精选热卖商品",
      cta: "查看全部",
      feature1: "品牌特惠好价",
      feature2: "精选热卖商品",
      feature3: "一个前台轻松选购",
      soldPrefix: "月销量"
    },
    products: { badge: "热门推荐", title: "每日推荐商品", all: "全部商品", items: "项", addToCart: "加入购物车" },
    flashSale: {
      badge: "限时抢购",
      title: "Flash Sale",
      desc: "精选热卖中国商品限时特价，让商城首页更有促销氛围与购买动力。",
      cta: "查看全部活动"
    },
    services: {
      badge: "在线商城模式",
      title: "像大型商城一样轻松购物",
      desc: "UCANBUY 作为中国进口商品在线商城，让普通买家更容易购物，也让商家更方便选品转售。",
      featuredBadge: "面向买家与商家的主商城",
      featuredTitle: "在同一前台选购已上架的中国商品",
      featuredDesc: "在一个购物流程中完成分类浏览、查看促销、比较价格、参考成本并下单。"
    },
    shipping: {
      badge: "成本估算器",
      title: "进口商品成本估算",
      pricePerKg: "每公斤价格",
      pricePerQ: "每立方价格",
      length: "长度 (厘米)",
      width: "宽度 (厘米)",
      height: "高度 (厘米)",
      weightLabel: "重量 (公斤)",
      volumeResult: "包装体积",
      weightResult: "重量",
      byWeightPrice: "按重量计价",
      byVolumePrice: "按体积计价",
      chargeByPrefix: "系统按以下方式估算",
      shippingFeePrefix: "预估物流成本",
      rule1: "按重量估算 (Kg.)",
      rule2: "按体积估算 (Q.)",
      note: "可用于估算平台商品的进口成本，或帮助转售商计算备货成本。"
    },
    why: { badge: "为什么选择 UCANBUY", title: "为什么用户选择在我们这里购物" },
    import: { badge: "精选系列", title: "热门系列与商品类型" },
    articles: { badge: "购物指南", title: "适合买家与转售商的实用文章" },
    footer: {
      menu: "主菜单",
      contact: "联系我们",
      start: "开始使用",
      tagline: "在一个平台上购买中国商品",
      desc: "该站点定位为中国进口商品商城，可继续扩展为分站或完整电商系统。",
      line: "LINE: {'@'}ucanbuyofficial",
      facebook: "Facebook: ucanbuyofficial",
      callCenter: "客服热线: 1336",
      supportHours: "周一至周六 08:30 - 17:00",
      copy: "© 2026 UCANBUY. 保留所有权利。"
    },
    cartPage: {
      badge: "购物车",
      title: "购物车",
      loginTitle: "登录后查看购物车",
      loginDesc: "您的购物车与订单会绑定到会员账号中。",
      emptyTitle: "购物车还是空的",
      emptyDesc: "请先在首页选择商品并加入购物车后再下单。",
      remove: "删除商品",
      summaryTitle: "订单摘要",
      totalItems: "商品数量",
      totalAmount: "合计金额",
      checkout: "创建订单",
      processing: "处理中..."
    },
    accountPage: {
      badge: "我的账户",
      title: "我的账户",
      loginTitle: "登录后查看账户信息",
      loginDesc: "登录后可查看会员资料、订单记录与购买状态。",
      email: "邮箱",
      phone: "手机号",
      lineId: "Line ID",
      usageType: "使用类型",
      ordersTitle: "订单列表",
      goToCart: "前往购物车",
      emptyOrdersTitle: "还没有订单",
      emptyOrdersDesc: "先将商品加入购物车并创建订单，即可开始使用电商流程。",
      orderNo: "订单编号",
      totalItems: "件数",
      totalAmount: "总金额",
      createdAt: "创建时间"
    },
    subhead: "商城会员",
    backHome: "返回首页",
    contact: "联系我们",
    heroTitle: "注册会员，开始购物或转售备货",
    heroDesc: "注册后即可在平台购买商品、追踪订单，并使用适合转售商的会员流程。",
    benefitsTitle: "会员权益",
    registerMock: {
      windowLabel: "Member Preview",
      title: "创建会员账号并完整使用在线商城",
      profileTitle: "会员账户已就绪",
      profileDesc: "可在一个界面中管理会员资料、订单与已关注商品",
      benefitOneTitle: "安全的注册流程",
      benefitOneDesc: "资料将写入真实数据库，并可继续扩展为完整账户系统",
      benefitTwoTitle: "更方便地购物与追踪订单",
      benefitTwoDesc: "通过一个账号访问活动、收藏商品与订单记录",
      statsTitle: "会员体验概览"
    },
    accountTitle: "账户信息",
    required: "* 请完整填写必要信息",
    gender: "性别",
    usageTitle: "会员使用信息",
    usageType: "您将如何使用平台",
    source: "您是通过什么渠道知道 UCANBUY 的？",
    selectSource: "请选择渠道",
    acceptTitle: "确认并接受条款",
    notRobot: "请确认您不是机器人",
    acceptPrefix: "我接受",
    terms: "服务条款",
    and: "和",
    privacy: "隐私政策",
    otpSent: "演示验证码已发送，系统已自动填入 123456。",
    otpFail: "无法发送验证码，请先检查手机号。",
    submitFail: "请再次检查您填写的信息。",
    submitSuccess: "注册成功，资料已写入数据库。"
  }
};
